export default __webpack_public_path__ + "assets/images/87ef342955f93072679c52cba5be2bae.png";